<nz-divider></nz-divider>
<h3>Inspection Finding:</h3>
<form nz-form  *ngIf="load" [formGroup]="inspectionFindingGroup">
  <div nz-row>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="mr-md" >
      <nz-form-label nzRequired>Actions</nz-form-label>
      <nz-form-control [nzErrorTip]="'Action is Required'" nzValidateStatus="validating">
        <nz-select reqiured id="selectedAction" formControlName="selectedAction">
          <nz-option *ngFor="let action of actions" [nzValue]="action.code" [nzLabel]="action.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
   <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="ml-lg" >
      <nz-form-label>Comments</nz-form-label>
      <nz-form-control nzValidateStatus="validating">
        <textarea rows="2" id="comments" formControlName="comments" nz-input></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button [disabled]="!inspectionFindingGroup.valid" id="onSubmit" nz-button (click)="onSubmit()">Submit</button>
    </div>
  </div>
</div>
</form>
